import React, { useState, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import CaretArrowDown from 'Components/Icons/CaretArrowDown'
import RightTick from 'Components/Icons/RightTick'
import Account from '../Icons/Account'
import Support from '../Icons/Support'
import useNavbar from './useNavbar'
import ContactUsModal from '../ContactUsModal'
import SupportCall from '../Icons/SupportCall'
import Cart from '../Icons/Cart'
import HeaderAvatar from '../Icons/HeaderAvatar'
import { hexToRgbA } from '../../utils/helper'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 34px 0 12px;
  gap: 16px;
`

const DropdownContainer = styled.div`
  position: relative;
  z-index: 10000;
  flex: 1;
`

const DropdownButton = styled.div`
  height: 44px;
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 11px;
  padding: 12px 16px;
  border-radius: 6px;
  background-color: ${props => hexToRgbA(props.theme.color.primaryText, 0.03)};
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${props => props.theme.color.primaryText};
  svg {
    margin-left: 6px;
    width: 12px;
    height: 12px;
  }
  path {
    fill: ${props => props.theme.color.primaryText};
  }
`

const IconsSection = styled.div`
  display: flex;
  margin-left: auto;
  gap: 6px;
  align-items: center;
`

const PermanentMenuItem = styled.a`
  cursor: pointer;
  overflow: hidden;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
  }

  svg {
    cursor: pointer;
    opacity: 0.7;
    border-radius: 24px;
    padding: 10px;
    border: 1px solid transparent;
    box-sizing: content-box;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &.active {
    svg {
      opacity: 1;
      background-color: ${props =>
        hexToRgbA(props.theme.color.primaryText, 0.05)};
    }
  }
  &:hover {
    svg {
      background-color: ${props =>
        hexToRgbA(props.theme.color.primaryText, 0.03)};
      opacity: 1;
      border: 1px solid ${props => props.theme.color.borderLight};
    }
  }
`

const DropdownMenu = styled.div`
  width: 100%;
  padding: 24px 16px 4px;
  box-sizing: border-box;
  position: absolute;
  top: 51px;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 12px 24px 0 rgba(52, 52, 52, 0.1),
    0 8px 16px 0 rgba(51, 51, 51, 0.1);
  background-color: ${props => props.theme.color.bg};
  border: 1px solid ${props => props.theme.color.borderLight || 'transparent'};
`

const DropdownOption = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: ${props => props.theme.color.primaryText};
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  path {
    fill: ${props => props.theme.color.primaryText};
  }
`

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Mweb = ({ items }) => {
  const theme = useTheme()
  const history = useHistory()
  const navbarSettings = useSelector(
    store => store.centerreducer?.regionsDetails?.client?.navbar_settings
  )

  const [isContactModalOpen, setContactModalOpen] = useState(false)
  const contactButtonRef = useRef(null)
  const {
    handleItemClick,
    isOpenDropdown,
    selectedItemIndex,
    toggleDropdown,
    isLoggedIn,
    commonMenuItems,
    loginMenuItem
  } = useNavbar(items, true)

  return (
    <>
      <NavContainer>
        {navbarSettings.length > 0 && (
          <DropdownContainer>
            <DropdownButton onClick={toggleDropdown}>
              {items[selectedItemIndex]?.title}
              {<CaretArrowDown expanded={isOpenDropdown} />}
            </DropdownButton>
            {isOpenDropdown && (
              <DropdownMenu>
                {commonMenuItems.map(dropdownItem => {
                  return (
                    <DropdownOption
                      key={dropdownItem.slug}
                      onClick={() => handleItemClick(dropdownItem.index)}
                    >
                      <Title>{dropdownItem.title}</Title>
                      {dropdownItem.index === selectedItemIndex && (
                        <RightTick />
                      )}
                    </DropdownOption>
                  )
                })}
              </DropdownMenu>
            )}
          </DropdownContainer>
        )}

        <IconsSection>
          <PermanentMenuItem
            ref={contactButtonRef}
            className={isContactModalOpen ? 'active' : ''}
            onClick={() => setContactModalOpen(true)}
          >
            <div>
              <SupportCall
                fill={
                  isContactModalOpen
                    ? theme.color.brand
                    : theme.color.primaryText
                }
              />
            </div>
          </PermanentMenuItem>
          <PermanentMenuItem
            className={
              window.location.pathname.includes('/cart') ? 'active' : ''
            }
            href="/cart"
          >
            <div>
              <Cart
                fill={
                  window.location.pathname.includes('/cart')
                    ? theme.color.brand
                    : theme.color.primaryText
                }
              />
            </div>
          </PermanentMenuItem>
          {isLoggedIn ? (
            <PermanentMenuItem
              className={
                window.location.pathname.includes('/my-account') ? 'active' : ''
              }
              onClick={() => {
                history.push(loginMenuItem?.url || '/my-account')
              }}
            >
              <div>
                <HeaderAvatar
                  fill={
                    window.location.pathname.includes('/my-account')
                      ? theme.color.brand
                      : theme.color.primaryText
                  }
                />
              </div>
            </PermanentMenuItem>
          ) : (
            <PermanentMenuItem
              onClick={() => {
                history.push(loginMenuItem?.url || '/my-account')
              }}
            >
              <div>
                <Account fill={theme.color.primaryText} />
              </div>
            </PermanentMenuItem>
          )}
        </IconsSection>
      </NavContainer>
      <ContactUsModal
        isOpen={isContactModalOpen}
        onClose={() => setContactModalOpen(false)}
        triggerRef={contactButtonRef}
      />
    </>
  )
}

export default Mweb
